import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getTokenWithoutUpdate } from "./authToken";
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'

export const isAuthenticated = () => {
  const token = getTokenWithoutUpdate();
  if (token && token !== "") {
    return true;
  }
  return false;
};

class PrivateRoute extends React.Component {
  
  constructor(props) {
    super(props)
    nprogress.start()
  }

  componentDidMount () {
    nprogress.done()
  }

  render() {
    const { component: Component, ...rest } = this.props;
    const isAuth = isAuthenticated();
    return (
      <Route
        {...rest}
        render={props =>
          isAuth ? <Component {...props} /> : <Redirect to="/login?error=unauthorized" />
        }
      />
    )
  }
}


export default PrivateRoute;
